export default __webpack_public_path__ + "static/media/fintech-guild-background.3c622afb.png";